export default __webpack_public_path__ + "static/media/category_3.1ced0a5e.png";